import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DinamicoService {

  constructor() { }
  getLogo(): string {
    const currentHost = window.location.hostname as keyof typeof environment.domains;
    return environment.domains[currentHost]?.logo || environment.domains.default.logo;
  }
  getTheme() {
    const currentHost = window.location.hostname as keyof typeof environment.domains;
    return environment.domains[currentHost]?.theme || environment.domains.default.theme;
  }
  getPrefijo() {
    const currentHost = window.location.hostname as keyof typeof environment.domains;
    return environment.domains[currentHost]?.prefijo || environment.domains.default.prefijo;
  }
}
